import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BuyCredits from './BuyCredits';
import CloseBtnModal from 'components/Button/CloseBtnModal';
import InvoiceInModal from './InvoiceInModal';
import { useDisclose } from 'basic-react-hooks';
import {
  cancelInvoice,
  getPublicUserInvoices,
} from 'rest_client/publicUserClient';
import { dispatchEvent } from 'hooks/useAddEvent';
import { EVENT_NAME } from 'constant/eventName';
import { useDispatch } from 'react-redux';
import { show } from 'redux/reducers/snackbar';

const ModalInvoiceBuy = ({ open, onClose: _onClose, _invoiceSelected }) => {
  const [invoices, setInvoices] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    isOpen: isLoadingCancel,
    onOpen: onOpenCancel,
    onClose: _onCloseCancel,
  } = useDisclose();

  const onClose = (checkLoading = true) => {
    if (checkLoading && loading) return;
    _onClose();
    setTimeout(() => setInvoices(null), 200);
  };

  useEffect(() => {
    if (_invoiceSelected && open) {
      setInvoices(_invoiceSelected);
    }
  }, [_invoiceSelected, open]);

  const isShowInvoice = Boolean(_invoiceSelected) || Boolean(invoices);

  const onClickCancelInvoice = async () => {
    onOpenCancel();
    setLoading(true);
    try {
      const { data } = await getPublicUserInvoices({
        page: 1,
        perPage: 10,
        search: invoices?.invoiceNumber,
      });
      const _invoice = data.data[0];
      if (_invoice.status !== 'wait_for_paying') {
        dispatchEvent(EVENT_NAME.fetchInvoices);
        if (_invoice.status === 'paid') {
          dispatch(
            show({ message: 'Invoice have been paid', severity: 'warning' }),
          );
        } else {
          dispatch(
            show({
              message: 'Invoice have been cancelled',
              severity: 'warning',
            }),
          );
        }
      } else {
        await cancelInvoice(invoices._id);
        dispatchEvent(EVENT_NAME.fetchInvoices);
        dispatch(
          show({ message: 'Invoice cancel successfully', severity: 'success' }),
        );
      }
      onClose(false);
    } catch (error) {
      dispatch(
        show({
          message: typeof error === 'string' ? error : error.message,
          severity: 'error',
        }),
      );
    }
    setLoading(false);
    _onCloseCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
      }}
      fullWidth
      maxWidth={'xs'}
      scroll="body"
      PaperProps={{
        sx: {
          bgcolor: isShowInvoice ? 'transparent' : 'white',
          boxShadow: isShowInvoice ? 'none' : '',
          borderRadius: '12px',
        },
      }}
    >
      <CloseBtnModal onClick={onClose} />
      {!isShowInvoice && (
        <BuyCredits
          onClose={onClose}
          setInvoices={setInvoices}
          setLoading={setLoading}
        />
      )}
      {isShowInvoice && (
        <InvoiceInModal
          loadingCancel={isLoadingCancel}
          invoices={invoices}
          onClickCancel={onClickCancelInvoice}
        />
      )}
    </Dialog>
  );
};

export default ModalInvoiceBuy;
